(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-homelocation.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-homelocation.js');
"use strict";

const {
  useSetAtom
} = jotai;
const {
  pinLocationAtom,
  pinLocationTypeAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  askPremisionToUseHomeLocation,
  showHomeLocationError
} = svs.lyckoplatsen.components.page_play.utils;
const {
  CONSTANTS
} = svs.lyckoplatsen.components.shared_constants;
const useHomeLocation = () => {
  const setPinLocation = useSetAtom(pinLocationAtom);
  const setPinLocationType = useSetAtom(pinLocationTypeAtom);
  const handler = async () => {
    if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      const shouldSignIn = await askPremisionToUseHomeLocation();
      if (shouldSignIn) {
        svs.utils.paramHandler.set({
          key: 'locationHome',
          value: true
        });
        const onboardingData = {
          returnNewCustomer: true,
          extraParams: {
            product: 'lyckoplatsen',
            branding: 'lyckoplatsen',
            forceShortOnboarding: true
          }
        };
        svs.components.customer_login.login(onboardingData);
      }
    } else {
      svs.ui.loader.show();
      try {
        const {
          playerGeoLocation
        } = svs.lyckoplatsen.data.homeLocation;
        const {
          Latitude: lat,
          Longitude: lng
        } = JSON.parse(playerGeoLocation);
        setPinLocation({
          lat,
          lng
        });
      } catch (e) {
        showHomeLocationError();
      }
      svs.ui.loader.hide();
      setPinLocationType(CONSTANTS.LOCATION_TYPES.HOME);
    }
  };
  return handler;
};
setGlobal('svs.lyckoplatsen.components.page_play.react.hooks', {
  useHomeLocation
});

 })(window);